export default "__VITE_ASSET__CNHNegyK__"